import React, { useState } from 'react'
import {
     FaEllipsisV, FaEnvelope,
    FaFlag, FaInfoCircle, FaMarker,
    FaMinusCircle,
    FaSave, FaShare, FaTimes
} from 'react-icons/fa'
import UserImage from "../../assets/user.png"
import { useNavigate } from 'react-router-dom'


const StoreAd = ({ ad }) => {

    // console.log("store_ad:", ad)

    const navigate = useNavigate()

    const [profileInfo, setProfileInfo] = useState(false)
    const [adInfo, setAdInfo] = useState(false)
    const [bannerUrl,setBannerUrl] = useState(ad?.store?.banner?.url)

    const products = ad?.store?.products || []


    const toggleAdInfo = () => {
        setProfileInfo(false)
        setAdInfo(prev => !prev)
    }

    const toggleProfileInfo = () => {
        setAdInfo(false)
        setProfileInfo(prev => !prev)
    }

    const renderImages = () => {
        return (
            <>
                <div className="focused-image">
                    <img
                        src={bannerUrl}
                        alt={ad?.store?.name || "store"}
                    />
                </div>

                {products.length > 0 && (
                    <div className="image-selector">
                        {products.map((product, i) => {

                            const fileUrl = product?.files?.[0]?.url
                            if (!fileUrl) return null

                            return (
                                <div
                                    key={i}
                                    className="image-selector-wrapper"
                                    onClick={() => setBannerUrl(fileUrl)}
                                >
                                    <img
                                        src={fileUrl}
                                        alt={product?.title || "product"}
                                    />
                                </div>
                            )
                        })}
                    </div>
                )}
            </>
        )
    }

    return (
        <div className='ad'>

            <div className="ad-header">
                <div className="profile-details"  onClick={() => navigate(`/b/${ad.store.name}`)}>
                    <img
                        src={ad?.store?.logo?.url || UserImage}
                        alt="store profile"
                        className="userad-profile-img"
                    />

                    <div className="ad-data-details">
                        <div className="ad-profile-name">
                            <p>{ad?.store?.name || "Business"}</p>
                        </div>
                    </div>
                    <p className='promoted-label'>promoted</p>
                </div>

                <div onClick={toggleProfileInfo}>
                    <FaEllipsisV />
                </div>
            </div>

            <div className="ad-body">

                <div className={profileInfo ? "profile-info" : "closed-info"}>
                    <FaTimes onClick={toggleProfileInfo} />
                    <div className="ad-button-wrapper">
                        <FaMarker />
                        <button className="ad-info-btn">Follow</button>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaEnvelope />
                        <button className="ad-info-btn">Message</button>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaMinusCircle />
                        <button className="ad-info-btn">Block</button>
                    </div>
                </div>

                <div className={adInfo ? "ad-info" : "closed-info"}>
                    <FaTimes onClick={toggleAdInfo} />
                    <div className="ad-button-wrapper">
                        <FaSave />
                        <button className="ad-info-btn">Bookmark</button>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaShare />
                        <button className="ad-info-btn">Share to</button>
                    </div>
                    <div className="ad-button-wrapper">
                        <FaFlag />
                        <button className="ad-info-btn">Report</button>
                    </div>
                </div>
                <div className="feed-ad-text">
                    <p>{ad?.store?.description || "Business"}</p>
                </div>

                <div className="adcard-images">
                    {renderImages()}
                </div>
            </div>

            <div className="ad-footer">
                <div className="ad-footer-icon">
                    <p onClick={()=>navigate(`/b/${ad.store.name}`,{state:{store:ad.store}})}>See More</p>
                </div>

                <div
                    className="ad-footer-icon"
                    onClick={toggleAdInfo}
                >
                    <FaInfoCircle />
                </div>

            </div>
        </div>
    )
}

export default StoreAd